import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, doc, addDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';

export const useCentroOperaciones = () => {
    const [productos, setProductos] = useState([]);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "costos_produccion"), (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setProductos(data);
            setCargando(false);
        }, (error) => {
            console.error("Error al cargar:", error);
            toast.error("Error cargando el catálogo");
            setCargando(false);
        });

        return () => unsubscribe();
    }, []);

    const agregarProducto = async (nuevo) => {
        try {
            await addDoc(collection(db, "costos_produccion"), {
                producto: nuevo.producto,
                costoBase: parseFloat(nuevo.costoBase) || 0,
                precioSugerido: parseFloat(nuevo.precioSugerido) || 0,
                createdAt: new Date().toISOString()
            });
            toast.success("¡Servicio añadido al catálogo!");
        } catch (error) {
            toast.error("Error al guardar el servicio");
        }
    };

    const editarProducto = async (id, datosEditados) => {
        try {
            await updateDoc(doc(db, "costos_produccion", id), {
                costoBase: parseFloat(datosEditados.costoBase) || 0,
                precioSugerido: parseFloat(datosEditados.precioSugerido) || 0
            });
            toast.success("¡Servicio actualizado!");
        } catch (error) {
            toast.error("Error al actualizar");
        }
    };

    const eliminarProducto = async (id) => {
        if (window.confirm("¿Seguro que deseas eliminar este servicio del catálogo?")) {
            try {
                await deleteDoc(doc(db, "costos_produccion", id));
                toast.success("Servicio eliminado");
            } catch (error) {
                toast.error("Error al eliminar");
            }
        }
    };

    // Exportamos solo lo que necesita el Centro de Operaciones de Eventos
    return {
        productos,
        cargando,
        agregarProducto,
        editarProducto,
        eliminarProducto
    };
};